import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Promesse } from '@components/promesse/models';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { ParallaxDirective } from '@shared/directives';

@Component({
  selector: 'app-promesse',
  templateUrl: './promesse.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, SvgComponent, NgClass, ParallaxDirective],
})
export class PromesseComponent extends AbstractDynamicComponent<Promesse> {}
